'use client';

import React__default from 'react';
import { colors } from '../Utils/constants.js';
import CheckIcon from './Icons/CheckIcon/index.js';
import WarningIcon from './Icons/WarningIcon/index.js';
import AttachIcon from './Icons/AttachIcon/index.js';
import QuestionMarkIcon from './Icons/QuestionMarkIcon/index.js';
import DangerIcon from './Icons/DangerIcon/index.js';
import ViewIcon from './Icons/ViewIcon/index.js';

var DEFAULT_COLOR = [
    {
        name: 'success',
        color: '#fff',
        backgroundColor: colors.successColor,
        icon: React__default.createElement(CheckIcon, null)
    },
    {
        name: 'warning',
        color: '#fff',
        backgroundColor: colors.buttonColor,
        icon: React__default.createElement(WarningIcon, null)
    },
    {
        name: 'default',
        color: '#fff',
        backgroundColor: colors.primaryColor,
        icon: React__default.createElement(AttachIcon, null)
    },
    {
        name: 'info',
        color: '#fff',
        backgroundColor: colors.infoColor,
        icon: React__default.createElement(QuestionMarkIcon, null)
    },
    {
        name: 'danger',
        color: '#fff',
        backgroundColor: colors.dangerColor,
        icon: React__default.createElement(DangerIcon, null)
    },
    {
        name: 'secondary',
        color: '#fff',
        backgroundColor: colors.secondaryColor,
        icon: React__default.createElement(ViewIcon, null)
    }
];
var DEFAULT_LIGHT_COLOR = [
    {
        name: 'success',
        color: colors.successColor,
        backgroundColor: '#D6EBE0',
        icon: React__default.createElement(CheckIcon, { isLight: true })
    },
    {
        name: 'warning',
        color: colors.buttonColor,
        backgroundColor: '#FFE5DD',
        icon: React__default.createElement(WarningIcon, { isLight: true })
    },
    {
        name: 'default',
        color: colors.primaryColor,
        backgroundColor: '#CCDEFF',
        icon: React__default.createElement(AttachIcon, { isLight: true })
    },
    {
        name: 'info',
        color: colors.infoColor,
        backgroundColor: '#DAEFFF',
        icon: React__default.createElement(QuestionMarkIcon, { isLight: true })
    },
    {
        name: 'danger',
        color: colors.dangerColor,
        backgroundColor: '#FFDBDD',
        icon: React__default.createElement(DangerIcon, { isLight: true })
    },
    {
        name: 'secondary',
        color: colors.secondaryColor,
        backgroundColor: '#E6EAF0',
        icon: React__default.createElement(ViewIcon, { isLight: true })
    }
];

export { DEFAULT_COLOR, DEFAULT_LIGHT_COLOR };
//# sourceMappingURL=constants.js.map
